<script lang="ts">
  import { Button, buttonVariants } from "$lib/components/ui/button";
  import * as Dialog from "$lib/components/ui/dialog/index.js";
  import { Input } from "$lib/components/ui/input";
  import { Label } from "$lib/components/ui/label";
  import { projectDraft } from "$src/application/projects/stores/projectStore";
  import { type PaymentSchedule } from "$src/domain/projects/details/PaymentSchedule";
  import { type ProjectPaymentSchedule } from "$src/domain/projects/ProjectDetail";
  import { formatCurrency } from "$src/presentation/core/currencyUtils";
  import { CornerLeftUp } from "lucide-svelte";
  import { createEventDispatcher } from "svelte";
  import { t } from "svelte-i18n";
  import { MoveRight } from "lucide-svelte";

  export let amount: number;
  export let projectSchedule: ProjectPaymentSchedule;

  let open: boolean;

  const dispatch = createEventDispatcher();

  function apply(): void {
    open = false;
    dispatch("scheduleUpdated");
  }

  function isAssignValid(payment: PaymentSchedule) : boolean {

    if( payment.paymentCompleted )
        return true;
    if( (payment.amount + amount) < 0 )
        return true;

    return false;
  }
</script>

<Dialog.Root bind:open>
  <Dialog.Trigger asChild let:builder>
    <Button builders={[builder]} size="sm" variant="secondary" >
      <CornerLeftUp class="mr-2 h-4 w-4" />
      {$t("page.projects.detail.schedule.assign-amount",
      {
        values: { amount: formatCurrency(amount, $projectDraft.prices.currency) },
      })}
    </Button>
  </Dialog.Trigger>
  <Dialog.Content class="sm:max-w-[425px]">
    <Dialog.Header>
      <Dialog.Title>
        {$t("page.projects.detail.schedule.assign-title")}
      </Dialog.Title>
    </Dialog.Header>
    <div class="flex flex-col gap-2">
      {#each projectSchedule.payments as payment}
          <Button disabled={isAssignValid(payment)}
            on:click={() => {
                payment.amount = payment.amount + amount
                apply();
            }}
          >
            <MoveRight class="mr-2 w-3 h-3" />
            {$t("page.projects.detail.schedule.payment")}
            {payment.paymentNumber}
          </Button>
      {/each}
    </div>
    <Dialog.Footer>
      <Button on:click={() => apply()}>
        {$t("global.messages.close")}
      </Button>
    </Dialog.Footer>
  </Dialog.Content>
</Dialog.Root>
